<template>
  <div class="searchHarm">
    <top :toolSort="toolSort"></top>
    <div class="touchLimitNav">
      <el-menu :router="true" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item :class="{mobileMenu:$isMobile}" @click='gotoSub(item.value)' v-for="(item,i) in beforeThreeNav" :key='i' :index="`${i}`">{{item.name}}</el-menu-item>
        <el-submenu index="4">
          <template slot="title">物理因素</template>
          <el-menu-item @click='gotoSub(item.value)' :index="`4-${i+1}`" v-for="(item,i) in physicTouchList" :key='i'>{{item.name}}</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <router-view></router-view>
  </div>

</template>
<script>
  import top from '../subComponents/top.vue'
  export default {
    data() {
      return {
        beforeThreeNav: [{
            name: '化学物质',
            value: 'chemistryTouchLimit'
          },
          {
            name: '粉尘',
            value: 'dustTouchLimit'
          },
          {
            name: '生物因素',
            value: 'biologicalTouchLimit'
          }
        ],
        physicTouchList: [{
            name: '超高频辐射',
            desc: '工作场所超高频辐射职业接触限值',
            value: 'ultraHighRadiationTouch',
          }, {
            name: '高频电磁场',
            value: 'highFrequencyElectromagnetic'
          }, {
            name: '工频电场',
            value: 'powerFrequencyElectric'
          }, {
            name: '眼直视激光束',
            value: 'eyeLaser'
          }, {
            name: '激光照射皮肤',
            value: 'laserIrradiation'
          }, {
            name: '微波',
            value: 'microwave'
          }, {
            name: '紫外辐射',
            value: 'ultravioletRadiation'
          }, {
            name: '体力劳动强度',
            value: 'labourIntensity'
          }, {
            name: '噪声',
            value: 'noise'
          }, {
            name: '脉冲噪声',
            value: 'impulseNoise'
          },
          {
            name: '手传振动',
            value: 'handBorneVibration'
          }, {
            name: '井下采掘',
            value: 'excavation'
          }
        ],
        activeIndex: '0',
        searchKey: '',
        toolSort: '',
        physicIndex:''
      }
    },
    components: {
      top,
    },
    watch: {
      '$route.name'(newVal) {
        this.matchRoute(newVal)
      }
    },
    created() {
      this.toolSort = this.$route.params.sort
      this.matchRoute(this.$route.name)
    },
    methods: {
      gotoSub(value) {
        this.$router.push({
          name: value,
          params: {
            sort: this.toolSort
          }
        })
      },
      //匹配路由
      matchRoute(name) {
        let count = 0
        this.beforeThreeNav.forEach((item, i) => {
          if (name == item.value) {
            this.activeIndex = i.toString()
            count++
          }
        })
        if (count == 0) {
          this.handleSelect()
          this.activeIndex ='4-1'
        }

      },
      handleSelect(key, keyPath) {

      }
    }



  }
</script>

<style>
  @import url("../../assets/iconfont.css");
  .el-dialog__title{
    font-size: 13px;
  }
  .el-menu-item{
    padding: 0 .9rem;
  }
  .json2excel{
    display: inline-block;
    margin-left: 1.25rem;
  }
  .el-tag{
    margin-right: 0.625rem;
    margin-bottom: 0.9375rem;
  }
  .el-select{
    margin-right: 0.625rem;
  }
  .el-table th>.cell {
    white-space: pre-line;
  }

  .title {
    text-align: center;
    margin: 0 auto;
    padding: 1.25rem;
    font-size: 13.5px;
    color: #666666;
    letter-spacing: 2px;
  }
  @media screen and (max-width: 300px) {
      .el-menu-item{
        padding: 0 .6rem;
      }
  }

  .el-table {
    margin-top: 0.625rem;
    -moz-box-shadow:0px 1px 7px #CFCFCF; -webkit-box-shadow:0px 1px 7px #CFCFCF; box-shadow:0px 1px 7px #CFCFCF;
  }
  .el-form-item {
    margin-bottom: 0;
  }

  .el-input {
    width: 10rem;
    font-size: 0.875rem;
    margin-bottom: 0.4375rem;
  }

  .iconsousuo {
    cursor: pointer;
    float: right;
  }

  .searchType {
    margin-top: 0.5rem;
    /* display: flex; */
  }
  .searchType .el-input{
    width: 20rem;
  }

  .typeLabel {
    font-size: 14px;
    color: #666;
  }

  .block {
    margin-top: 0.9375rem;
    text-align: center;
  }

  .el-tabs--border-card {
    margin-top: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/subPage/touchLimit.vue